export const myDriveKeys = {
    OPEN_MY_DRIVE: 'OPEN_MY_DRIVE',
    TOGGLE_QUIZ: 'TOGGLE_QUIZ',
}
